import api from "app/lib/api";
import endpoints from "static/endpoints";
import { interpolate } from "utils/string";

export const getAllManufacturerAccounts = async () => {
  const { data } = await api.get(endpoints.manufacturer.manufacturerAccounts);
  return data;
};

export const createManufacturerAccount = async (payload) => {
  const response = await api.post(
    endpoints.manufacturer.manufacturerAccounts,
    payload
  );
  return response;
};

export const getActiveManufacturerAccounts = async () => {
  const response = await api.get(
    endpoints.manufacturer.activeManufacturerAccounts
  );
  return response;
};

export const updateManufacturerAccount = async (id, payload) => {
  const url = interpolate(endpoints.manufacturer.manufacturerAccountById, {
    id,
  });
  const response = await api.patch(url, payload);
  return response;
};

export const toggleManufacturerAccountStatus = async (id, payload) => {
  const url = interpolate(
    endpoints.manufacturer.manufacturerAccountStatusById,
    {
      id,
    }
  );
  const response = await api.patch(url, payload);
  return response;
};

export const deleteManufacturerAccount = async (id) => {
  const url = interpolate(endpoints.manufacturer.manufacturerAccountById, {
    id,
  });
  const response = await api.delete(url);
  return response;
};

export const changeManufacturerAccountPassword = async (id, payload) => {
  const url = interpolate(
    endpoints.manufacturer.manufacturerAccountChangePassword,
    {
      id,
    }
  );
  const response = await api.patch(url, payload);
  return response;
};
